export const SEARCH_TOKEN_BY_ID_STRUCT = 'assets/tokenid/issuingBox';

export const UNSPENT_SELL_ORDERS_BY_TOKEN_ID_STRUCT =
  '/dex/tokens/tokenid/unspentSellOrders';

export const UNSPENT_BUY_ORDERS_BY_TOKEN_ID_STRUCT =
  '/dex/tokens/tokenid/unspentBuyOrders';

export const GET_ALL_ISSUED_TOKENS_STRUCT = '/assets/issuingBoxes';

export const GET_TOTAL_ISSUED_TOKENS_STRUCT = '/assets/issuingBoxes/total';

export const GET_ISSUED_TOKENS_BY_ID_STRUCT = 'assets/id:/issuingBoxes';

export const GET_UNCONFIRMED_TRANSACTIONS_STRUCT = '/transactions/unconfirmed';

export const GET_UNCONFIRMED_TRANSACTION_STRUCT =
  '/transactions/unconfirmed/:id';

export const GET_TOKEN_STRUCT = '/tokens/:id';

export const GET_ORACLE_POOL_DATA_STRUCT = 'oracle/frontendData';

export const GET_ORACLE_POOL_INFO_V2_STRUCT = 'oracle/v2/poolInfo';

export const GET_ORACLE_POOL_STATUS_V2_STRUCT = 'oracle/v2/poolStatus';

export const GET_ORACLE_INFO_V2_STRUCT = 'oracle/v2/oracleInfo';

export const GET_ORACLE_STATUS_V2_STRUCT = 'oracle/v2/oracleStatus';

export const GET_ADDRESSES_BALANCES_STRUCT = 'addresses/balances';
